export interface ZoomSignatureState {
  signature: string;
}

const state: ZoomSignatureState = {
  signature: '',
};

export default state;
